import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';
import { IconProps, Icon } from 'core/common/ui/ui-kit';
import { pointerHoverMediaQuery } from '../constants';

export const getSelectOptions = ({ palette }: Theme) => {
  const selectComponents = {
    defaultProps: {
      IconComponent: (props: IconProps) => <Icon {...props} name="arrow-rounded" />,
    },
    variants: [
      {
        props: { variant: 'outlined' },
        style: {
          borderRadius: '30px',
          backgroundImage: 'none',
          [`& ${globalClasses.selectIcon}`]: {
            transition: 'transform 0.2s',
            right: '20px',
            width: '24px',
            height: '24px',
            top: '50%',
            transform: ' rotate(0deg) translate(0%, -50%)',
            transformOrigin: 'top',
            fill: 'currentColor',
          },
          [`& ${globalClasses.outlinedInputLine}`]: {
            border: `1px solid ${palette.input.main}`,
            [pointerHoverMediaQuery]: {
              '&:hover': {
                border: `1px solid ${palette.input.mainHover}`,
              },
            },
            '&:focus': {
              border: `2px solid ${palette.input.mainFocus}`,
            },
          },
          [`&& ${globalClasses.inputBase}`]: {
            paddingLeft: '14px',
            paddingRight: '45px',
            paddingTop: '13px',
            paddingBottom: '13px',
          },
          [`& ${globalClasses.selectIconOpen}`]: {
            transform: ' rotate(180deg) translate(0%, -50%)',
          },
        },
      },
    ],
  };

  return { selectComponents };
};
